
import gaokaoPerms from './directives/gaokaoPerms'
import drag from './directives/drag'

const modules = {
    gaokaoPerms,
    drag
}

export default {
    // 自定义指令
    install(app) {
        Object.keys(modules).forEach((key) => {
            app.directive(key, modules[key])
        })
    }
}
